import {Button, Grid, Typography} from '@material-ui/core';
import messages from '@super-template/messages';
import {FormattedMessage, useIntl} from 'react-intl';
import {format} from 'date-fns';
import useDateFnsCurrentLocale from '@super-template/core/src/locale/useDateFnsLocale';
import {makeStyles} from '@material-ui/core/styles';
import getTranslated from '@super-template/core/src/locale/getTranslated';
import {getAttachment} from "api";
import SaveIcon from '@material-ui/icons/Save';
import {snackbarError} from '@super-template/core/src/snackbar';

const useStyles = makeStyles((theme) => ({
  gridRoot: {
    [theme.breakpoints.down('xs')]: {
      '& .top': {
        paddingBottom: 0,
      },
      '& .bottom': {
        paddingTop: 0,
      },
    },
  },
  htmlContent: {
    '& *': {
      margin: 0
    }
  }
}));

const Row = ({label, html, div, children}) => {
  const classes = useStyles();
  return (
    <Grid container spacing={3} className={classes.gridRoot}>
      <Grid item xs={12} sm={4} className={'top'}>
        <Typography>
          <strong>
            <FormattedMessage {...label} />
          </strong>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={8} className={'bottom'}>
        {html ? <div className={classes.htmlContent} dangerouslySetInnerHTML={{__html: children}}/> :
          children && (div ? children : <Typography>{children}</Typography>)}
      </Grid>
    </Grid>
  );
};
const isEmpty = (o) => Object.values(o).every(x => x === null || x === '');

const download = ({data, name}) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.style.display = 'none';
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export default function Content({info, organization, main, num, locale, isHolidayOrganization}) {
  const localeFns = useDateFnsCurrentLocale();
  const intl = useIntl();
  const fetchAttachment = async (name) => {
    const data = await getAttachment({organization, id: info.id, name});
    if (data.error) snackbarError("Virhe ladattaessa liitetiedostoa");
    else download({data, name});
  };

  return (
    <>
      {main ?
        <Row label={messages.search_end_date}>
          {format(new Date(info.applicationEndDate), 'P', {locale: localeFns})}
        </Row> :
        <Typography variant="h6" component="h3" style={{marginTop: 15}} gutterBottom>
          <strong>
            {messages[`followup_${num}`] ?
              <FormattedMessage {...messages[`followup_${num}`]}/> :
              <FormattedMessage {...messages.followup}/>}
          </strong>
        </Typography>}
      <Row label={isHolidayOrganization ? messages.holiday_target : messages.course_target}>
        {info.resortOrganization.www ?
          <a target={'_blank'} rel="noreferrer" href={info.resortOrganization.www}>
            {info.resortOrganization.name}
          </a> : info.resortOrganization.name}
      </Row>
      {main && <Row label={isHolidayOrganization ? messages.holiday_theme : messages.course_theme}>
        {getTranslated(info.themeName, locale)}
      </Row>}
      <Row label={isHolidayOrganization ? messages.holiday_time : messages.course_time}>
        {format(new Date(info.startDate), 'P', {locale: localeFns})}-
        {format(new Date(info.endDate), 'P', {locale: localeFns})}
      </Row>
      {info.budgeting?.adultDayCoPayment &&
      <Row label={messages.holiday_price}>
        {info.budgeting.adultDayCoPayment}{' '}
        <FormattedMessage {...messages.adult_copayment} />
        {info.budgeting.childDayCoPrice && ', ' + info.budgeting.childDayCoPrice + ' ' +
        intl.formatMessage(messages.child_copayment)}
      </Row>}
      {main && info.partnerOrganization &&
      <Row label={messages.partner}>
        {info.partnerOrganization.www ?
          <a target={'_blank'} rel="noreferrer" href={info.partnerOrganization.www}>
            {info.partnerOrganization.name}
          </a> : info.partnerOrganization.name}
      </Row>}
      {main && !isEmpty(info.holidayRestrictions) &&
      <Row label={isHolidayOrganization ? messages.holiday_restrictions : messages.course_restrictions}>
        {getTranslated(info.holidayRestrictions, locale)}
      </Row>}
      {!isEmpty(info.description) &&
      <Row label={messages.holiday_description} html={true}>
        {getTranslated(info.description, locale)}
      </Row>}
      {(info.attachments && info.attachments.length > 0) &&
      <Row label={isHolidayOrganization ? messages.holiday_more : messages.course_more} div>
        {info.attachments.map((a, index) =>
          <div key={`att_${index}`}>
            <Button className={"as-link"} onClick={() => fetchAttachment(a.name)}>
              <SaveIcon style={{marginRight: 10}}/>{a.name}
            </Button>
          </div>)}
      </Row>}
    </>
  );
}
